import { render } from "./TradePreviewModalGP.vue?vue&type=template&id=0579c312&scoped=true&ts=true"
import script from "./TradePreviewModalGP.vue?vue&type=script&lang=ts"
export * from "./TradePreviewModalGP.vue?vue&type=script&lang=ts"

import "./TradePreviewModalGP.vue?vue&type=style&index=0&id=0579c312&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0579c312"]])

export default __exports__